export default __webpack_public_path__ + "static/media/retro3.eae1ad31.jpg";